<template>
  <div>
    <DpplTooltip
      v-if="showMyJobs && enforcedMyJobsEnabled"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <MyJobsToggle
          is-disabled
          @filters-tracking-event="emit('filters-tracking-event', $event)"
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        />
      </template>
      <template #tooltip-content>
        <p class="tooltip-content">
          You are only allowed to see jobs that are your own
        </p>
      </template>
    </DpplTooltip>
    <MyJobsToggle
      v-else
      :is-disabled="isLoading"
      @filters-tracking-event="emit('filters-tracking-event', $event)"
    />
  </div>
</template>

<script setup>
import MyJobsToggle from '@/components/filter/filterMenu/MyJobsToggle.vue';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

defineProps({
  isLoading: { type: Boolean, default: false },
  showMyJobs: { type: Boolean, default: true },
  enforcedMyJobsEnabled: { type: Boolean, default: false },
});

const emit = defineEmits(['filters-tracking-event']);
</script>

<style lang="less" scoped>
.tooltip-content {
  font-size: 13px;
  font-weight: 500;
  color: @text-light;
}
</style>
